import Home from './views/home/index.vue'
export default {
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    }
  ]
}